module.exports = __webpack_public_path__ + "static/media/tiendachat-new-bot-message-notification-sound.c17f727f.mp3";